import {
  Option
} from "./chunk-MDHIJGDW.mjs";

// src/dropdown-menu/src/dropdown-option-reactnode.tsx
import { jsx } from "react/jsx-runtime";
var isOptionReactNode = (input) => (
  // eslint-disable-next-line @typescript-eslint/no-unsafe-return, @typescript-eslint/no-unsafe-member-access, @typescript-eslint/no-unsafe-call
  Object(input).hasOwnProperty("children")
);
var OptionReactNode = ({ children, ...props }) => (
  // eslint-disable-next-line react/jsx-props-no-spreading
  /* @__PURE__ */ jsx(Option, { asChild: true, ...props, children })
);

export {
  isOptionReactNode,
  OptionReactNode
};
